module.exports = __webpack_public_path__ + "img/LI.3dc5cca8.svg";